module.exports = "/static/media/chairman_Icon.a0737d28.svg";